module.exports = __webpack_public_path__ + "static/greatsword-486388675c00f97bbab9a98fe378eba9.jpg";